import React, { useState } from 'react'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import TextInput from '../../../components/UIComponent/TextInput'
import ModalBasic from '../../component/ModalBasic'

export const PartyAccountMasterPopup = (props) => {

    const [open, setOpen] = useState(false);

    return (
        <ModalBasic
            id="partryMaster"
            classParams="!w-[80%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
            onClose={() => { setOpen(false); }}
        >
            <div className='input-fields p-[30px]'>
                <div className='item-grp'>
                    <div className="tabbing-btns flex gap-5 items-center mb-3">
                        <span className={` text-[16px] py-[5px] px-[15px] rounded-[8px] font-semibold cursor-pointer ${open ? "text-blue bg-lightBlue hover:bg-[#3f8cff33]" : "text-white bg-blue"}`} onClick={() => setOpen(false)}>Basic details</span>
                        <span className={` text-[16px] py-[5px] px-[15px] rounded-[8px] font-semibold cursor-pointer ${open ? "text-white bg-blue" : "text-blue bg-lightBlue hover:bg-[#3f8cff33]"}`} onClick={() => setOpen(true)}>Other details</span>
                    </div>
                    {!open && (
                        <>
                            <span className="text-blue text-[16px] font-semibold">Party account details</span>
                            <div className="item-inner mb-2 pb-[8px] border-b border-slate-200 mt-2.5">
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5 mb-2.5">
                                    <div className="input-grp">
                                        <label>Select type</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Select type"
                                            options={props.partyObject.types}
                                            // value={props.partyObject.selectedType}
                                            value={props.partyObject.selectedTypeId ? props.partyObject.types.find(x => x.value === props.partyObject.selectedTypeId) : 0}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedType")
                                            }
                                            className={` ${props.validState?.error?.selectedTypeId ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Inv. type</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Select type"
                                            options={props.partyObject.invTypeList}
                                            // value={props.partyObject.seletecINVType}
                                            value={props.partyObject.seletecINVTypeId ? props.partyObject.invTypeList.find(x => x.value === props.partyObject.seletecINVTypeId) : 0}
                                            onChange={(event) =>
                                                props.handleChange(event, "seletecINVType")
                                            }
                                            className={` ${props.validState?.error?.seletecINVTypeId ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Party code</label>
                                        <TextInput
                                            type="number"
                                            id="partyCode"
                                            name="partyCode"
                                            value={props.partyObject.partyCode}
                                            disabled={true}
                                        //handleChange={(event) => props.handleChange(event, "partyCode")} disabled
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Party type</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Party type"
                                            options={props.partyObject.partyTypes}
                                            // value={props.partyObject.selectedPartyType}
                                            value={props.partyObject.selectedPartyTypeId ? props.partyObject.partyTypes.find(x => x.value === props.partyObject.selectedPartyTypeId) : 0}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedPartyType")
                                            }
                                            className={` ${props.validState?.error?.selectedPartyTypeId ? "error" : ""}`}
                                        />
                                    </div>
                                </div>
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5">
                                    <div className="input-grp col-span-2">
                                        <label>Party name</label>
                                        <TextInput
                                            type="text"
                                            id="partyName"
                                            name="partyName"
                                            value={props.partyObject.partyName}
                                            handleChange={(event) => props.handleChangeForFields(event, "partyName")}
                                            className={` ${props.validState?.error?.partyName ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Party group</label>
                                        <TextInput
                                            type="text"
                                            id="partyGroup"
                                            name="partyGroup"
                                            value={props.partyObject.partyGroup}
                                            handleChange={(event) => props.handleChangeForFields(event, "partyGroup")}
                                            className={` ${props.validState?.error?.idGeneralProduct ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Category</label>
                                        <TextInput
                                            type="text"
                                            id="category"
                                            name="category"
                                            value={props.partyObject.category}
                                            handleChange={(event) => props.handleChangeForFields(event, "category")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <span className="text-blue text-[16px] font-semibold">Basic information</span>
                            <div className="item-inner mt-2.5 mb-5">
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5 mb-2.5">
                                    <div className="input-grp">
                                        <label>Contact person</label>
                                        <TextInput
                                            type="text"
                                            id="contactPerson"
                                            name="contactPerson"
                                            value={props.partyObject.contactPerson}
                                            handleChange={(event) => props.handleChangeForFields(event, "contactPerson")}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>TDS group</label>
                                        <MultiSelectDropdown
                                            drpIdentity="TDS group"
                                            options={props.partyObject.tdsGroups}
                                            value={props.partyObject.selectTDSGroups}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectTDSGroups")
                                            }
                                            className={` ${props.validState?.error?.tdsGrp ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>TDS(%)</label>
                                        <TextInput
                                            type="text"
                                            id="tdsPer"
                                            name="tdsPer"
                                            value={props.partyObject.tdsPer}
                                            //handleChange={(event) => props.handleChange(event, "tdsPer")}
                                            disabled={true}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Email ID</label>
                                        <TextInput
                                            type="text"
                                            id="email"
                                            name="email"
                                            value={props.partyObject.email}
                                            handleChange={(event) => props.handleChangeForFields(event, "email")}
                                            className={` ${props.validState?.error?.email ? "error" : ""}`}
                                        />
                                    </div>
                                    {/* <div className="input-grp">
                                        <label>Whatsapp no</label>
                                        <TextInput
                                            type="number"
                                            id="whatsApp"
                                            name="whatsApp"
                                            value={props.partyObject.whatsApp}
                                            handleChange={(event) => props.handleChangeForFields(event, "whatsApp")}
                                            className={` ${props.validState?.error?.whatsApp ? "error" : ""}`}
                                        />
                                    </div> */}
                                    <div className="input-grp">
                                        <label>Contact no</label>
                                        <TextInput
                                            type="number"
                                            id="contactNo1"
                                            name="contactNo1"
                                            value={props.partyObject.contactNo1}
                                            handleChange={(event) => props.handleChangeForFields(event, "contactNo1")}
                                            className={` ${props.validState?.error?.contactNo1 ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Website</label>
                                        <TextInput
                                            type="text"
                                            id="website"
                                            name="website"
                                            value={props.partyObject.website}
                                            handleChange={(event) => props.handleChangeForFields(event, "website")}
                                            className={` ${props.validState?.error?.website ? "error" : ""}`}
                                        />
                                    </div>
                                    {/* <div className="input-grp">
                                        <label>Contact no</label>
                                        <TextInput
                                            type="number"
                                            id="contactNo2"
                                            name="contactNo2"
                                            value={props.partyObject.contactNo2}
                                            handleChange={(event) => props.handleChangeForFields(event, "contactNo2")}
                                            className={` ${props.validState?.error?.contactNo2 ? "error" : ""}`}
                                        />
                                    </div> */}
                                    {/* <div className="input-grp">
                                        <label>Date of birth</label>
                                        <TextInput
                                            type="date"
                                            id="dob"
                                            name="dob"
                                            value={props.partyObject.dob}
                                            handleChange={(event) => props.handleChangeForFields(event, "dob")}
                                            className={` ${props.validState?.error?.dob ? "error" : ""}`}
                                        />
                                    </div> */}
                                    <div className="input-grp">
                                        <label>GST no</label>
                                        <TextInput
                                            type="text"
                                            id="gstNo"
                                            name="gstNo"
                                            value={props.partyObject.gstNo}
                                            handleChange={(event) => props.handleChangeForFields(event, "gstNo")}
                                            className={` ${props.validState?.error?.gstNo ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>GST date</label>
                                        <TextInput
                                            type="date"
                                            id="gstDate"
                                            name="gstDate"
                                            value={props.partyObject.gstDate}
                                            handleChange={(event) => props.handleChangeForFields(event, "gstDate")}
                                            className={` ${props.validState?.error?.gstNo ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>PAN no</label>
                                        <TextInput
                                            type="text"
                                            id="panNo"
                                            name="panNo"
                                            value={props.partyObject.panNo}
                                            handleChange={(event) => props.handleChangeForFields(event, "panNo")}
                                            className={` ${props.validState?.error?.panNo ? "error" : ""}`}
                                        />
                                    </div>
                                </div>
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5 mb-2.5">
                                    <div className="input-grp col-span-2 row-span-2">
                                        <label>Address</label>
                                        <textarea
                                            rows={4}
                                            type="text"
                                            id="address"
                                            name="address"
                                            value={props.partyObject.address}
                                            onChange={(event) => props.handleChangeForFields(event, "address")}
                                            className={`h-full ${props.validState?.error?.address ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Country</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Country"
                                            options={props.partyObject.countrys}
                                            value={props.partyObject.selectedCountry}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedCountry")
                                            }
                                            className={` ${props.validState?.error?.country ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>State</label>
                                        <MultiSelectDropdown
                                            drpIdentity="State"
                                            options={props.partyObject.masterState}
                                            value={props.partyObject.selectedMasterState}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedMasterState")
                                            }
                                            className={` ${props.validState?.error?.state ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>State code</label>
                                        <TextInput
                                            type="number"
                                            id="stateCode"
                                            name="stateCode"
                                            value={props.partyObject.stateCode}
                                            handleChange={(event) => props.handleChangeForFields(event, "stateCode")}
                                            className={` ${props.validState?.error?.stateCode ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>City</label>
                                        <MultiSelectDropdown
                                            drpIdentity="City"
                                            options={props.partyObject.masterCity}
                                            value={props.partyObject.selectedMasterCity}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedMasterCity")
                                            }
                                            className={` ${props.validState?.error?.state ? "error" : ""}`}
                                        />
                                    </div>

                                </div>
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5 mb-2.5">
                                    <div className="input-grp">
                                        <label>Place of sup.</label>
                                        <TextInput
                                            type="text"
                                            id="place"
                                            name="place"
                                            value={props.partyObject.place}
                                            handleChange={(event) => props.handleChangeForFields(event, "place")}
                                            className={` ${props.validState?.error?.place ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Acc. Sub head</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Acc sub head"
                                            options={props.partyObject.generalProducts}
                                            value={props.partyObject.selectedGeneralProduct}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedGeneralProduct")
                                            }
                                            className={` ${props.validState?.error?.idGeneralProduct ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>OP stock</label>
                                        <TextInput
                                            type="text"
                                            id="opStock"
                                            name="opStock"
                                            value={props.partyObject.opStock}
                                            handleChange={(event) => props.handleChangeForFields(event, "opStock")}
                                            className={` ${props.validState?.error?.place ? "error" : ""}`}
                                        />
                                    </div>
                                </div>
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5 mb-2.5">
                                    {/* <div className='input-grp !inline-flex !gap-[10px]'>
                                        <label>Is leave:</label>
                                        <input type='CheckBox'
                                            className='shadow-none w-[15px] h-[15px]'
                                            id='isGSTParty' name='isGSTParty'
                                            value={props.partyObject.isGSTParty}
                                            checked={props.partyObject.isGSTParty}
                                            onClick={(event) => props.handleChangeForFields(event, 'isGSTParty')}
                                        />
                                    </div> */}
                                </div>
                            </div>
                            <div className="btn-grp inline-flex gap-2.5">

                                <button className="update-btn btns"
                                    onClick={() => { props.submit(); setOpen(false); }}
                                >
                                    {props.partyObject.idPartyAccount > 0 ? "Update" : "Save"}
                                </button>
                                <button className="delete-btn btns" onClick={() => { props.close(); setOpen(false) }}>Cancel</button>
                                {/* <button className="update-btn btns"
                                    onClick={() => setOpen(true)}
                                >
                                    Next
                                </button> */}
                            </div>
                        </>
                    )}
                    {open && (
                        <>
                            <span className="text-blue text-[16px] font-semibold">Account details</span>
                            <div className='item-inner mt-2.5'>
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5 mb-2 pb-[8px] border-b border-slate-200">
                                    <div className="input-grp">
                                        <label>Opening balance</label>
                                        <TextInput
                                            type="number"
                                            id="opBalance"
                                            name="opBalance"
                                            value={props.partyObject.opBalance}
                                            handleChange={(event) => props.handleChangeForFields(event, "opBalance")}
                                            className={` ${props.validState?.error?.opBalance ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Op Balance Date</label>
                                        <TextInput
                                            type="date"
                                            id="opDate"
                                            name="opDate"
                                            value={props.partyObject.opDate}
                                            handleChange={(event) => props.handleChangeForFields(event, "opDate")}
                                            className={` ${props.validState?.error?.opDate ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Current balance</label>
                                        <TextInput
                                            type="number"
                                            id="currentBalance"
                                            name="currentBalance"
                                            value={props.partyObject.currentBalance}
                                            handleChange={(event) => props.handleChangeForFields(event, "currentBalance")}
                                            disabled
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Balance type</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Balance type"
                                            options={props.partyObject.balanceTypes}
                                            value={props.partyObject.selectedBalanceType}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedBalanceType")
                                            }
                                            className={` ${props.validState?.error?.balanceTypeId ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp col-span-2">
                                        <label>Employee Name</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Employee name"
                                            options={props.partyObject.employeeList}
                                            value={props.partyObject.selectedEmployeeName}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectedEmployeeName")
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <span className="text-blue text-[16px] font-semibold">Registration details</span>
                            <div className='item-inner mt-2.5'>
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5 mb-2 pb-[8px] border-b border-slate-200">
                                    <div className="input-grp col-span-2">
                                        <label>Bank name</label>
                                        <TextInput
                                            type="text"
                                            id="bankName"
                                            name="bankName"
                                            value={props.partyObject.bankName}
                                            handleChange={(event) => props.handleChangeForFields(event, "bankName")}
                                            className={` ${props.validState?.error?.bankName ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Account holder</label>
                                        <TextInput
                                            type="text"
                                            id="accHolder"
                                            name="accHolder"
                                            value={props.partyObject.accHolder}
                                            handleChange={(event) => props.handleChangeForFields(event, "accHolder")}
                                            className={` ${props.validState?.error?.accHolder ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Branch name</label>
                                        <TextInput
                                            type="text"
                                            id="branchName"
                                            name="branchName"
                                            value={props.partyObject.branchName}
                                            handleChange={(event) => props.handleChangeForFields(event, "branchName")}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Account no</label>
                                        <TextInput
                                            type="number"
                                            id="accountNo"
                                            name="accountNo"
                                            value={props.partyObject.accountNo}
                                            handleChange={(event) => props.handleChangeForFields(event, "accountNo")}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>IFSC code</label>
                                        <TextInput
                                            type="text"
                                            id="ifsc"
                                            name="ifsc"
                                            value={props.partyObject.ifsc}
                                            handleChange={(event) => props.handleChangeForFields(event, "ifsc")}
                                            className={` ${props.validState?.error?.ifsc ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Branch city</label>
                                        <TextInput
                                            type="text"
                                            id="branchCity"
                                            name="branchCity"
                                            value={props.partyObject.branchCity}
                                            handleChange={(event) => props.handleChangeForFields(event, "branchCity")}
                                        />
                                    </div>
                                </div>
                            </div>
                            <span className="text-blue text-[16px] font-semibold">Extra details</span>
                            <div className='item-inner mt-2.5'>
                                <div className="inputOuter-grp grid grid-cols-4 gap-2.5 items-center">
                                    <div className="input-grp col-span-2">
                                        <label>Invoice discount</label>
                                        <TextInput
                                            type="number"
                                            id="invoiceDis"
                                            name="invoiceDis"
                                            value={props.partyObject.invoiceDis}
                                            handleChange={(event) => props.handleChangeForFields(event, "invoiceDis")}
                                            className={` ${props.validState?.error?.invoiceDis ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className='input-grp !inline-flex !gap-[5px] mt-4'>
                                        <label>Apply discount:</label>
                                        <input type='CheckBox'
                                            className='shadow-none w-[15px] h-[15px]'
                                            id='isDiscount' name='isDiscount'
                                            value={props.partyObject.isDiscount}
                                            checked={props.partyObject.isDiscount}
                                            onClick={(event) => props.handleChangeForFields(event, 'isDiscount')}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>P. Terms</label>
                                        <MultiSelectDropdown
                                            drpIdentity="Terms"
                                            options={props.partyObject.terms}
                                            value={props.partyObject.selectPTerms}
                                            onChange={(event) =>
                                                props.handleChange(event, "selectPTerms")
                                            }
                                            className={` ${props.validState?.error?.pTerms ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Credit limit</label>
                                        <TextInput
                                            type="number"
                                            id="creditLimit"
                                            name="creditLimit"
                                            value={props.partyObject.creditLimit}
                                            handleChange={(event) => props.handleChangeForFields(event, "creditLimit")}
                                        />
                                    </div>
                                    <div className="input-grp">
                                        <label>Special remarks</label>
                                        <TextInput
                                            type="text"
                                            id="remarks"
                                            name="remarks"
                                            value={props.partyObject.remarks}
                                            handleChange={(event) => props.handleChangeForFields(event, "remarks")}
                                            className={` ${props.validState?.error?.remarks ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className='input-grp !inline-flex !gap-[5px]'>
                                        <label>This party will be used for job work entries.</label>
                                        <input type='CheckBox'
                                            className='shadow-none w-[15px] h-[15px]'
                                            id='isJobWork' name='isJobWork'
                                            value={props.partyObject.isJobWork}
                                            checked={props.partyObject.isJobWork}
                                            onClick={(event) => props.handleChangeForFields(event, 'isJobWork')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="btn-grp inline-flex gap-2.5 mt-5">

                                <button className="update-btn btns"
                                    onClick={() => { props.submit(); setOpen(false) }}
                                >
                                    {props.partyObject.idPartyAccount > 0 ? "Update" : "Save"}
                                </button>
                                <button className="delete-btn btns" onClick={() => { props.close(); setOpen(false) }}>Cancel</button>
                                {/* <button className="update-btn btns"
                                    onClick={() => setOpen(true)}
                                >
                                    Next
                                </button> */}
                            </div>
                        </>
                    )}
                </div>
            </div>

        </ModalBasic>
    )
}
